/**
 * Webhook registration — M6 slice B, ADR-0041.
 *
 * **The closed allow-list of event types is stated here, once** (P2-7g). It lived in the API until
 * the Ops console began naming each type in words, and a list a screen draws must be one the bundles
 * can be held to. The API keys each type's stream and description by this list and a test holds the
 * two to one another, so it is still stated once rather than restated in two packages. What zod checks
 * at registration is shape; what the service checks is membership, and it names the unknown type back
 * so a typo is fixable rather than silent.
 */
import { z } from 'zod';
import { renderedText } from './rendered-text.js';
/** The events a Merchant may subscribe to, in the order the catalogue offers them (ADR-0041). */
export const WEBHOOK_EVENT_TYPES = [
    'order.accepted',
    'order.cancelled.pre_acceptance',
    'order.cancelled.pre_pickup',
    'leg.pickup.confirmed',
    'leg.delivery.started',
    'leg.delivery.attempt_failed',
    'leg.delivery.confirmed',
    'rto.initiated',
    'rto.closed',
    'sla.breached',
];
/** A delivery's state, as `webhook_deliveries_status` admits it. */
export const WEBHOOK_DELIVERY_STATUSES = ['pending', 'delivered', 'abandoned'];
export const registerWebhookSchema = z.object({
    /**
     * https is asserted three times — here, by a CHECK on the table, and again at fetch time
     * (ADR-0041). Not redundancy for its own sake: this one gives the Merchant a 400 they can
     * act on, the CHECK makes a bad row unrepresentable, and the fetch-time check is the only
     * one that sees what the host resolves to *now*.
     */
    url: z.string().url().max(2000).startsWith('https://', 'webhook_url_https'),
    eventTypes: z.array(z.string().trim().min(1).max(80)).min(1).max(50),
    description: z.string().trim().max(200).optional(),
});
/** The URL and description come back on the register response and on the endpoint list. */
export const registerWebhookRendered = renderedText(registerWebhookSchema, {
    prose: ['description'],
    refs: ['url'],
    exempt: {
        eventTypes: 'each must name a type on the closed webhook allow-list (webhook_event_type_unknown) before any write',
    },
});
export const setWebhookStatusSchema = z.object({
    status: z.enum(['active', 'disabled']),
});
export const setWebhookStatusRendered = renderedText(setWebhookStatusSchema, {});
//# sourceMappingURL=webhooks.js.map